export default __webpack_public_path__ + "static/media/Musizierende-Katzen.cc0d65f7.png";